import LayersClearIcon from '@mui/icons-material/LayersClear';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import clsx from 'clsx';
import { DropDown } from '../DropDown';
import { SelectedFilters } from '../FilterBarWrapper/SelectedFilters';
import { UserFilters } from '../Modals/UserFilters';
import {
  ADVANCED_FILTER_BUTTON_ID,
  OTHER_ACTIONS_BUTTON_ID,
  PAGE_ACTION_MAIN_ID,
  PRESET_BUTTON_ID,
} from './PageActions.constant';
import { usePageActionsStyles } from './PageActions.style';

export const PageActions = ({
  onOpenFilters,
  openFiltersLabel = 'All Filters',
  openFiltersDisabled = false,
  openFiltersStartIcon,
  onClearFilters,
  presets,
  mainAction,
  secondaryAction,
  actions,
  allFilters,
  checkListItems,
  className,
}) => {
  const classes = usePageActionsStyles();

  return (
    <div className={clsx(classes.buttonSection, className)}>
      {!!allFilters && !!checkListItems && (
        <SelectedFilters allFilters={allFilters} checkListItems={checkListItems} />
      )}

      <Tooltip title='Clear Filters'>
        <IconButton onClick={onClearFilters} className={classes.iconButton} size='medium'>
          <LayersClearIcon className={classes.icon} />
        </IconButton>
      </Tooltip>

      <div className={classes.leftButtonSection}>
        {presets && (
          <UserFilters
            id={PRESET_BUTTON_ID}
            filters={presets.filters}
            setFilters={presets.setFilters}
            context={presets.context}
            googleAnalyticsTag={presets.tag}
            includeShare={presets.includeShare}
            iconButtonClass={classes.iconButton}
            label={presets.label}
            ShareComponent={presets.ShareComponent}
            LoadComponent={presets.LoadComponent}
            SaveComponent={presets.SaveComponent}
          />
        )}

        {onOpenFilters && (
          <Button
            id={ADVANCED_FILTER_BUTTON_ID}
            className={classes.button}
            onClick={onOpenFilters}
            variant='contained'
            color='secondary'
            disabled={openFiltersDisabled}
            startIcon={openFiltersStartIcon}
          >
            {openFiltersLabel}
          </Button>
        )}
      </div>
      {(!!mainAction || !!actions) && (
        <div
          className={clsx(classes.pageActions, {
            [classes.pageActionsWithSecondary]: !!secondaryAction,
          })}
        >
          {!!secondaryAction && <i className={classes.pageActionsVerticalLine} />}
          {!!mainAction && (
            <Tooltip title={mainAction.tooltip} className={classes.button}>
              <span>
                <Button
                  id={PAGE_ACTION_MAIN_ID}
                  className={classes.button}
                  startIcon={mainAction.icon}
                  variant='outlined'
                  color='secondary'
                  onClick={mainAction.onClick}
                  disabled={mainAction.disabled}
                >
                  {mainAction.label}
                </Button>
              </span>
            </Tooltip>
          )}
          {!!secondaryAction && (
            <Tooltip title={secondaryAction.tooltip} className={classes.button}>
              <span>
                <Button
                  id={PAGE_ACTION_MAIN_ID}
                  className={classes.button}
                  startIcon={secondaryAction.icon}
                  variant='contained'
                  color='tertiary'
                  onClick={secondaryAction.onClick}
                  disabled={secondaryAction.disabled}
                >
                  {secondaryAction.label}
                </Button>
              </span>
            </Tooltip>
          )}

          {!!actions && (
            <DropDown
              dropDownContent={
                <div style={{ color: 'white', padding: '.5rem' }}>
                  {actions.map(action => (
                    <Button
                      key={action.label}
                      startIcon={action.icon}
                      variant='text'
                      onClick={action.onClick}
                      disabled={action.disabled}
                    >
                      {action.label}
                    </Button>
                  ))}
                </div>
              }
              iconButtonClass={classes.iconButton}
            >
              <MoreVertIcon id={OTHER_ACTIONS_BUTTON_ID} />
            </DropDown>
          )}
        </div>
      )}
    </div>
  );
};
